<template>
  <!-- The live state in the nav: green with the time left while live, blue
       while the person is in an instant call. -->
  <span
    v-if="store.enabled && (store.inCall || store.isLive)"
    class="hidden items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap sm:inline-flex"
    :class="
      store.inCall
        ? 'bg-primary-50 text-primary-700'
        : 'bg-success-50 text-success-800'
    "
  >
    <span
      class="size-1.5 rounded-full"
      :class="store.inCall ? 'bg-primary-500' : 'bg-success-500 animate-pulse'"
    />
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useInstantSessionsStore } from '@/modules/instant-sessions/stores/instantSessions'

const store = useInstantSessionsStore()

// Ticks every 30 s, which is enough for "1:42 left".
const now = ref(Date.now())
let timer: number | null = null
onMounted(() => {
  timer = window.setInterval(() => (now.value = Date.now()), 30_000)
})
onBeforeUnmount(() => {
  if (timer !== null) window.clearInterval(timer)
})

const label = computed(() => {
  if (store.inCall) return 'In a call'
  if (!store.liveUntil) return 'Live'
  const minutes = Math.max(
    0,
    Math.round((new Date(store.liveUntil).getTime() - now.value) / 60_000),
  )
  if (minutes < 10) return `Live · ${minutes} min left`
  const hours = Math.floor(minutes / 60)
  return `Live · ${hours}:${String(minutes % 60).padStart(2, '0')} left`
})
</script>
